const WISHLIST_BTN_SELECTOR = '[data-swaction="addToWishlist"]';

const loadingEl = document.querySelector('.wcg__wishlist-loading');
const emptyEl = document.querySelector('.wcg__wishlist-empty');
const productsEl = document.querySelector('.wcg__wishlist-products');
const productGridEl = document.getElementById('product-grid');
const productGridType = window.wishlistConfig.type || 'product';

(function() {
  function onSwymLoadCallback(swat) {
    document.addEventListener('click', (e) => {
      if(e.target && e.target.closest('.card__button-remove')) {
        const removeButtonEl = e.target.closest('.card__button-remove');
        const gridItemEl = e.target.closest('.grid__item');
        const wishlistObj = {
          du: removeButtonEl.dataset.productUrl,
          empi: parseInt(removeButtonEl.dataset.productId),
          epi: parseInt(removeButtonEl.dataset.variantId),
        };

        swat.fetch((products) => {
          products.forEach((product) => {
            if(productGridType === 'variant' && product.empi === wishlistObj.empi && product.epi === wishlistObj.epi) {
              wishlistRemove(swat, product, gridItemEl, true);
            } else if (productGridType === 'product' && product.empi === wishlistObj.empi) {
              wishlistRemove(swat, product, gridItemEl, true);
            }
          });
        })
      }
    });
    
    swat.fetch(async (products) => {
      const finalResults = await getProductsHtml(products);
      if(finalResults.length > 0) {
        finalResults.forEach((result, index) => {
          const productHtml = new DOMParser().parseFromString(result, 'text/html');
          const newProductEl = productHtml.cloneNode(true);
          productGridEl.appendChild(newProductEl.querySelector('.grid__item'));
        });
        productsEl.classList.remove('hidden');
        loadingEl.classList.add('hidden');
        document.dispatchEvent(new CustomEvent('lazyloadProductGrid'));
      } else {
        loadingEl.classList.add('hidden');
        emptyEl.classList.remove('hidden');
      }
    });
    
  }
  if (!window.SwymCallbacks) {  
    window.SwymCallbacks = [];  
  }  
  window.SwymCallbacks.push(onSwymLoadCallback);
})();


if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

async function getProductsHtml(products) {
  const productUrls = productGridType === 'variant' ?
                                          products.map(el => `${el.du.match(/\/products\/[^?\/"]*/g)}/?variant=${el.epi}&section_id=wcg-${productGridType}-wishlist`) :
                                          Array.from(new Set(products.map(el => `${el.du.match(/\/products\/[^?\/"]*/g)}/?section_id=wcg-${productGridType}-wishlist`)));
  try {
    const rawResults = await Promise.all(productUrls.map(url => fetch(url)));
    return await Promise.all(rawResults.map(result => result.text()));
  } catch(err) {
    console.error(err);
    return err;
  }
}

function wishlistRemove(swat, wishlistObj, gridItemEl, forceRemove = false) {
  if(!swat || !wishlistObj) return;
  swat.removeFromWishList(wishlistObj, (response) => {
    if(forceRemove === true) {
      gridItemEl.remove();
      if(productGridEl.childElementCount === 0) {
        productsEl.classList.add('hidden');
        emptyEl.classList.remove('hidden');
        document.dispatchEvent(new CustomEvent('lazyloadProductGrid'));
        document.querySelectorAll('.card__button-save').forEach((btn) => {
          btn.classList.remove('disabled', 'swym-added', 'swym-adding');
        });
        document.dispatchEvent(new CustomEvent('swym:initializeActionButtons'));
      }
    } else {
      document.body.dispatchEvent(new CustomEvent('wishlist:product:processingEnd', { bubbles: true, detail: { el: gridItemEl, product: wishlistObj }}));
      document.body.dispatchEvent(new CustomEvent('wishlist:product:removed', { bubbles: true, detail: { el: gridItemEl, product: wishlistObj }}));
    }
// console.log('product successfully removed from wishlist', response);
  }, (error) => {
// console.log('there was an error while removing the product from wishlist', error, product);
  });
}

